import { render, staticRenderFns } from "./IPQCSeleItem.vue?vue&type=template&id=7e5c8056&scoped=true"
import script from "./IPQCSeleItem.vue?vue&type=script&lang=js"
export * from "./IPQCSeleItem.vue?vue&type=script&lang=js"
import style0 from "./IPQCSeleItem.vue?vue&type=style&index=0&id=7e5c8056&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5c8056",
  null
  
)

export default component.exports